export default "__VITE_ASSET__Bc8zZ5ji__"